export default __webpack_public_path__ + "static/media/oaken.9032ba50.jpg";